var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoBonusEngine24X24 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_29084",
    "data-name": "Group 29084",
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.999,
    height: 18,
    viewBox: "0 0 19.999 18",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_13336",
    "data-name": "Rectangle 13336",
    width: 19.999,
    height: 18,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_29083",
    "data-name": "Group 29083",
    clipPath: "url(#clip-path)",
    fill: "#999"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_48323",
    "data-name": "Path 48323",
    d: "M20,2.932V5.461c0,1.821-4.79,1.9-5.74,1.9-.27,0-.86-.01-1.55-.061a7.488,7.488,0,0,0-4.19-3.019V2.932c0,1.67,4.09,1.9,5.74,1.9S20,4.6,20,2.932"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48324",
    "data-name": "Path 48324",
    d: "M14.257,0c-.952,0-5.742.092-5.742,1.9s4.79,1.9,5.742,1.9S20,3.708,20,1.9,15.209,0,14.257,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48325",
    "data-name": "Path 48325",
    d: "M20,6.451v2.53c0,1.81-4.79,1.9-5.74,1.9h-.29a7.245,7.245,0,0,0-.68-2.55c.37.01.7.02.97.02,1.66,0,5.74-.23,5.74-1.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48326",
    "data-name": "Path 48326",
    d: "M20,9.972V12.5c0,1.811-4.79,1.9-5.74,1.9-.281,0-.56-.01-.84-.021a7.044,7.044,0,0,0,.559-2.519c.091.009.191.009.281.009,1.66,0,5.74-.229,5.74-1.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48327",
    "data-name": "Path 48327",
    d: "M20,13.491v2.54c0,1.81-4.79,1.9-5.74,1.9a18.347,18.347,0,0,1-3.43-.32,7.35,7.35,0,0,0,2.1-2.27c.44.04.89.05,1.33.05,1.66,0,5.74-.23,5.74-1.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48328",
    "data-name": "Path 48328",
    d: "M6.5,5A6.5,6.5,0,1,0,13,11.5,6.5,6.5,0,0,0,6.5,5m1.912,7.494a.2.2,0,0,0-.074.231L9.5,15.968a.2.2,0,0,1-.317.221l-2.55-2.137a.2.2,0,0,0-.257,0L3.823,16.193a.2.2,0,0,1-.317-.225l1.161-3.243a.2.2,0,0,0-.074-.231L1.825,10.576a.2.2,0,0,1,.127-.364l3.286.156a.2.2,0,0,0,.2-.149l.871-3.312a.2.2,0,0,1,.244-.142.2.2,0,0,1,.143.142l.868,3.313a.2.2,0,0,0,.2.149l3.288-.157a.2.2,0,0,1,.123.364Z"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoBonusEngine24X24);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_bonus_engine24x24.f1e422a891acabe39fd0921b039e5b6c.svg";